import { render } from "./Church.vue?vue&type=template&id=7a4deba9"
import script from "./Church.vue?vue&type=script&lang=js"
export * from "./Church.vue?vue&type=script&lang=js"

import exportComponent from "E:\\doc\\projects\\copAccraCrusade\\cfan\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__